import { useLanguage } from '@/contexts/LanguageContext';
import { Package2, Shield, Clock, Truck } from 'lucide-react';
import Image from 'next/image';

const features = [
  {
    icon: <Image src='/icons/quality.svg' width={36} height={36} className="w-9 h-9 object-contain" alt="Quality Icon" />,
    title: "Various and Durable Stainless Steel Materials",
    title_ar: "خامات ستانلس ستيل متينة ومتنوعة"
  },
  {
    icon: <Image src='/icons/warranty.svg' width={36} height={36} className="w-9 h-9 object-contain" alt="Warranty Icon" />,
    title: "1 Year Warranty & After Sale Service",
    title_ar: "ضمان سنة واحدة وخدمة ما بعد البيع"
  },
  {
    icon: <Image src='/icons/experience.svg' width={36} height={36} className="w-9 h-9 object-contain" alt="Experience Icon" />,
    title: "24 Years of Solid Experience",
    title_ar: "24 عاماً من الخبرة القوية"
  },
  {
    icon: <Image src='/icons/shipping.svg' width={36} height={36} className="w-9 h-9 object-contain" alt="Shipping Icon" />,
    title: "Free Delivery and Installation in UAE ",
    title_ar: "توصيل وتركيب مجاني داخل الإمارات"
  },
  {
    icon: <Image src='/icons/prices.svg' width={36} height={36} className="w-9 h-9 object-contain" alt="Prices Icon" />,
    title: "Expedited Execution and Exceptional Final Project",
    title_ar: "تنفيذ سريع ونتائج استثنائية"
  }
];


const FeatureGrid2 = () => {
  const{language} = useLanguage();
  const isRTL = language === "ar";
  return (
    <div className="px-4 sm:container pb-4 md:pb-8  ">
          <div className=' grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-0   border rounded-lg rounded-t-none'>
      {features.map((feature, index) => (
      
        <div
          key={index}
          className={`flex gap-5 p-3 md:p-6 hover:bg-gray-50 transition-colors duration-200 border-gray-200
            ${index > 0 ? 'border-t sm:border-t-0 sm:border-l' : ''}
            
          `}
        >
          {feature.icon}
         
            <h3 className="font-semibold text-[12px] 2xl:text-[14px] 3xl:text-[16px] text-[#262626] font-primary trackin-wider mt-2 md:mt-0">{isRTL ? feature.title_ar : feature.title}</h3>
            {/* <p className="text-sm text-gray-600">{feature.description}</p> */}
         
        </div>
      ))}
    </div>
    </div>
  );
};

export default FeatureGrid2;